// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchServicewiseRevenue } from "../../../state/reducers/serviceRevenueSlice";
// import { Bar } from "react-chartjs-2";
// import "chart.js/auto";

// const ServicewiseRevenueChart = () => {
//   const dispatch = useDispatch();
//   const { monthly, yearly, status, error } = useSelector((state) => state.servicewiseRevenue);
//   const [groupBy, setGroupBy] = useState("month"); // Default grouping: month
//   const [reportType, setReportType] = useState("Analytics"); // Default report type: Analytics
//   const [generateClicked, setGenerateClicked] = useState(false);

//   useEffect(() => {
//     dispatch(fetchServicewiseRevenue(groupBy)); // Fetch data for the selected group (month/year)
//   }, [dispatch, groupBy]);

//   const handleGenerate = () => {
//     setGenerateClicked(true); // Set flag to true when Generate is clicked
//   };

//   const getChartData = () => {
//     if (status === "succeeded") {
//       if (groupBy === "month" && monthly) {
//         const categories = monthly.map((record) => record.category);
//         const revenues = monthly.map((record) =>
//           record.yearly_data.flatMap((yearData) =>
//             yearData.monthly_revenue.reduce((sum, monthData) => sum + monthData.total_revenue, 0)
//           )
//         );

//         return {
//           labels: categories,
//           datasets: [
//             {
//               label: `Monthly Revenue`,
//               data: revenues,
//               backgroundColor: "#1e40af",
//               borderColor: "#00008B",
//               borderWidth: 1,
//             },
//           ],
//         };
//       }

//       if (groupBy === "year" && yearly) {
//         const categories = yearly.map((record) => record.category);
//         const revenues = yearly.map((record) =>
//           record.yearly_revenue.reduce((sum, yearData) => sum + yearData.total_revenue, 0)
//         );

//         return {
//           labels: categories,
//           datasets: [
//             {
//               label: `Yearly Revenue`,
//               data: revenues,
//               backgroundColor: "#1e40af",
//               borderColor: "#00008B",
//               borderWidth: 1,
//             },
//           ],
//         };
//       }
//     }

//     return {
//       labels: [],
//       datasets: [
//         {
//           label: "No Data Available",
//           data: [],
//         },
//       ],
//     };
//   };

//   const renderList = () => {
//     if (generateClicked && status === "succeeded") {
//       let revenueData = [];

//       if (groupBy === "month" && monthly) {
//         revenueData = monthly.flatMap((record) =>
//           record.yearly_data.flatMap((yearData) =>
//             yearData.monthly_revenue.map((monthData) => ({
//               category: record.category,
//               month: monthData.month,
//               total_revenue: monthData.total_revenue,
//             }))
//           )
//         );
//       } else if (groupBy === "year" && yearly) {
//         revenueData = yearly.flatMap((record) =>
//           record.yearly_revenue.map((yearData) => ({
//             category: record.category,
//             year: yearData.year,
//             total_revenue: yearData.total_revenue,
//           }))
//         );
//       }

//       if (revenueData.length === 0) {
//         return <div className="text-center text-gray-500">No data available</div>;
//       }

//       return (
//         <div className="bg-white p-6 rounded-lg shadow-lg">
//           <h3 className="text-xl font-semibold mb-4">Revenue Data</h3>
//           <table className="min-w-full">
//             <thead>
//               <tr>
//                 <th className="px-4 py-2 text-left">Category</th>
//                 <th className="px-4 py-2 text-left">{groupBy === "month" ? "Month" : "Year"}</th>
//                 <th className="px-4 py-2 text-left">Revenue</th>
//               </tr>
//             </thead>
//             <tbody>
//               {revenueData.map((item, index) => (
//                 <tr key={index}>
//                   <td className="px-4 py-2">{item.category}</td>
//                   <td className="px-4 py-2">{item.month || item.year}</td>
//                   <td className="px-4 py-2">{item.total_revenue}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       );
//     }

//     return <div className="text-center text-gray-500">No data available</div>;
//   };

//   const chartData = getChartData();

//   return (
//     <div className="bg-white p-6 rounded-md shadow-md">
//       <div className="flex justify-between items-center mb-4">
//         <h1 className="text-xl font-bold">Servicewise Revenue Report</h1>
//         <div className="flex gap-4">
//           <button
//             onClick={() => setGroupBy("month")}
//             className={`px-4 py-2 rounded-md ${
//               groupBy === "month" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"
//             }`}
//           >
//             Monthly
//           </button>
//           <button
//             onClick={() => setGroupBy("year")}
//             className={`px-4 py-2 rounded-md ${
//               groupBy === "year" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"
//             }`}
//           >
//             Yearly
//           </button>
//         </div>
//       </div>

//       <div className="flex gap-4">
//         <select
//           className="px-4 py-2 rounded-md"
//           value={reportType}
//           onChange={(e) => setReportType(e.target.value)}
//         >
//           <option value="Analytics">Analytics</option>
//           <option value="List">List</option>
//         </select>
//         <button
//           onClick={handleGenerate}
//           className="bg-blue-500 text-white px-4 py-2 rounded"
//         >
//           Generate
//         </button>
//       </div>

//       {status === "loading" && <p className="text-gray-500">Loading...</p>}
//       {status === "failed" && <p className="text-red-500">{error}</p>}

//       {reportType === "Analytics" ? (
//         <Bar
//           data={chartData}
//           options={{
//             responsive: true,
//             plugins: {
//               legend: { display: true },
//             },
//             scales: {
//               y: {
//                 beginAtZero: true,
//               },
//             },
//           }}
//         />
//       ) : (
//         renderList()
//       )}
//     </div>
//   );
// };

// export default ServicewiseRevenueChart;


// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchServicewiseRevenue } from "../../../state/reducers/serviceRevenueSlice";
// import { Bar } from "react-chartjs-2";
// import "chart.js/auto";

// const ServicewiseRevenueChart = () => {
//   const dispatch = useDispatch();
//   const { monthly, status, error } = useSelector((state) => state.servicewiseRevenue);
//   const [groupBy, setGroupBy] = useState("month"); // Default grouping: month
//   const [selectedMonth, setSelectedMonth] = useState("January"); // Default month: January
//   const [reportType, setReportType] = useState("Analytics"); // Default report type: Analytics
//   const [generateClicked, setGenerateClicked] = useState(false);

//   useEffect(() => {
//     dispatch(fetchServicewiseRevenue(groupBy)); // Fetch data for the selected group (month/year)
//   }, [dispatch, groupBy]);

//   const handleGenerate = () => {
//     setGenerateClicked(true); // Set flag to true when Generate is clicked
//   };

//   const fixedCategories = [
//     "Abroad counseling",
//     "Test Preparation",
//     "Other Services",
//     "Career Counseling",
//     "Profile Building",
//   ];

//   const getChartData = () => {
//     if (status === "succeeded" && groupBy === "month" && monthly) {
//       const revenues = fixedCategories.map((category) => {
//         const categoryData = monthly.find((record) => record.category === category);
//         if (categoryData) {
//           return categoryData.yearly_data.flatMap((yearData) =>
//             yearData.monthly_revenue
//               .filter((monthData) => monthData.month === selectedMonth)
//               .reduce((sum, monthData) => sum + monthData.total_revenue, 0)
//           );
//         }
//         return 0;
//       });

//       return {
//         labels: fixedCategories,
//         datasets: [
//           {
//             label: `Revenue for ${selectedMonth}`,
//             data: revenues,
//             backgroundColor: "#1e40af",
//             borderColor: "#00008B",
//             borderWidth: 1,
//           },
//         ],
//       };
//     }

//     return {
//       labels: fixedCategories,
//       datasets: [
//         {
//           label: "No Data Available",
//           data: Array(fixedCategories.length).fill(0),
//         },
//       ],
//     };
//   };

//   const chartData = getChartData();

//   return (
//     <div className="bg-white p-6 rounded-md shadow-md">
//       <div className="flex justify-between items-center mb-4">
//         <h1 className="text-xl font-bold">Servicewise Revenue Report</h1>
//         <div className="flex gap-4">
//           <button
//             onClick={() => setGroupBy("month")}
//             className={`px-4 py-2 rounded-md ${
//               groupBy === "month" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"
//             }`}
//           >
//             Monthly
//           </button>
//                   <button
//             onClick={() => setGroupBy("year")}
//             className={`px-4 py-2 rounded-md ${
//               groupBy === "year" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"
//             }`}
//           >
//             Yearly
//           </button>
//         </div>
//       </div>

//       <div className="flex gap-4">
//         <select
//           className="px-4 py-2 rounded-md"
//           value={selectedMonth}
//           onChange={(e) => setSelectedMonth(e.target.value)}
//         >
//           {[
//             "January",
//             "February",
//             "March",
//             "April",
//             "May",
//             "June",
//             "July",
//             "August",
//             "September",
//             "October",
//             "November",
//             "December",
//           ].map((month) => (
//             <option key={month} value={month}>
//               {month}
//             </option>
//           ))}
//         </select>
//         <select
//           className="px-4 py-2 rounded-md"
//           value={reportType}
//           onChange={(e) => setReportType(e.target.value)}
//         >
//           <option value="Analytics">Analytics</option>
//           <option value="List">List</option>
//         </select>
//         <button
//           onClick={handleGenerate}
//           className="bg-blue-500 text-white px-4 py-2 rounded"
//         >
//           Generate
//         </button>
//       </div>

//       {status === "loading" && <p className="text-gray-500">Loading...</p>}
//       {status === "failed" && <p className="text-red-500">{error}</p>}

//       {reportType === "Analytics" ? (
//         <Bar
//           data={chartData}
//           options={{
//             responsive: true,
//             plugins: {
//               legend: { display: true },
//             },
//             scales: {
//               y: {
//                 beginAtZero: true,
//               },
//             },
//           }}
//         />
//       ) : (
//         <div className="text-center text-gray-500">No list view available for this configuration</div>
//       )}
//     </div>
//   );
// };

// export default ServicewiseRevenueChart;


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchServicewiseRevenue } from "../../../state/reducers/serviceRevenueSlice";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

const ServicewiseRevenueChart = () => {
  const dispatch = useDispatch();
  const { monthly, yearly, status, error } = useSelector((state) => state.servicewiseRevenue);
  const [groupBy, setGroupBy] = useState("month"); // Default grouping: month
  const [selectedMonth, setSelectedMonth] = useState("January"); // Default month: January
  const [selectedYear, setSelectedYear] = useState(2025); // Default year: 2025
  const [reportType, setReportType] = useState("Analytics"); // Default report type: Analytics
  const [generateClicked, setGenerateClicked] = useState(false);

  useEffect(() => {
    dispatch(fetchServicewiseRevenue(groupBy)); // Fetch data for the selected group (month/year)
  }, [dispatch, groupBy]);

  const handleGenerate = () => {
    setGenerateClicked(true); // Set flag to true when Generate is clicked
  };

  const fixedCategories = [
    "Abroad counseling",
    "Test Preparation",
    "Other Services",
    "Career Counseling",
    "Profile Building",
  ];

  const getChartData = () => {
    if (status === "succeeded") {
      if (groupBy === "month" && monthly) {
        const revenues = fixedCategories.map((category) => {
          const categoryData = monthly.find((record) => record.category === category);
          if (categoryData) {
            return categoryData.yearly_data
              .filter((yearData) => yearData.year === selectedYear)
              .flatMap((yearData) =>
                yearData.monthly_revenue
                  .filter((monthData) => monthData.month === selectedMonth)
                  .reduce((sum, monthData) => sum + monthData.total_revenue, 0)
              );
          }
          return 0;
        });

        return {
          labels: fixedCategories,
          datasets: [
            {
              label: `Revenue for ${selectedMonth} ${selectedYear}`,
              data: revenues,
              backgroundColor: "#1e40af",
              borderColor: "#00008B",
              borderWidth: 1,
            },
          ],
        };
      }

      if (groupBy === "year" && yearly) {
        const revenues = fixedCategories.map((category) => {
          const categoryData = yearly.find((record) => record.category === category);
          if (categoryData) {
            return categoryData.yearly_revenue
              .filter((yearData) => yearData.year === selectedYear)
              .reduce((sum, yearData) => sum + yearData.total_revenue, 0);
          }
          return 0;
        });

        return {
          labels: fixedCategories,
          datasets: [
            {
              label: `Revenue for ${selectedYear}`,
              data: revenues,
              backgroundColor: "#1e40af",
              borderColor: "#00008B",
              borderWidth: 1,
            },
          ],
        };
      }
    }

    return {
      labels: fixedCategories,
      datasets: [
        {
          label: "No Data Available",
          data: Array(fixedCategories.length).fill(0),
        },
      ],
    };
  };
  const renderList = () => {
    if (generateClicked && status === "succeeded") {
      let revenueData = [];

      if (groupBy === "month" && monthly) {
        revenueData = monthly.flatMap((record) =>
          record.yearly_data.flatMap((yearData) =>
            yearData.monthly_revenue.map((monthData) => ({
              category: record.category,
              month: monthData.month,
              total_revenue: monthData.total_revenue,
            }))
          )
        );
      } else if (groupBy === "year" && yearly) {
        revenueData = yearly.flatMap((record) =>
          record.yearly_revenue.map((yearData) => ({
            category: record.category,
            year: yearData.year,
            total_revenue: yearData.total_revenue,
          }))
        );
      }

      if (revenueData.length === 0) {
        return <div className="text-center text-gray-500">No data available</div>;
      }

      return (
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h3 className="text-xl font-semibold mb-4">Revenue Data</h3>
          <table className="min-w-full">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left">Category</th>
                <th className="px-4 py-2 text-left">{groupBy === "month" ? "Month" : "Year"}</th>
                <th className="px-4 py-2 text-left">Revenue</th>
              </tr>
            </thead>
            <tbody>
              {revenueData.map((item, index) => (
                <tr key={index}>
                  <td className="px-4 py-2">{item.category}</td>
                  <td className="px-4 py-2">{item.month || item.year}</td>
                  <td className="px-4 py-2">{item.total_revenue}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return <div className="text-center text-gray-500">No data available</div>;
  };
  const chartData = getChartData();

  return (
    <div className="bg-white p-6 rounded-md shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Servicewise Revenue Report</h1>
        <div className="flex gap-4">
          <button
            onClick={() => setGroupBy("month")}
            className={`px-4 py-2 rounded-md ${
              groupBy === "month" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"
            }`}
          >
            Monthly
          </button>
          <button
            onClick={() => setGroupBy("year")}
            className={`px-4 py-2 rounded-md ${
              groupBy === "year" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"
            }`}
          >
            Yearly
          </button>
        </div>
      </div>

      <div className="flex gap-4">
        {groupBy === "month" && (
          <select
            className="px-4 py-2 rounded-md"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>
        )}

        <select
          className="px-4 py-2 rounded-md"
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
        >
          {[2023, 2024, 2025, 2026, 2027].map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

        <select
          className="px-4 py-2 rounded-md"
          value={reportType}
          onChange={(e) => setReportType(e.target.value)}
        >
          <option value="Analytics">Analytics</option>
          <option value="List">List</option>
        </select>
        <button
          onClick={handleGenerate}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Generate
        </button>
      </div>

      {status === "loading" && <p className="text-gray-500">Loading...</p>}
      {status === "failed" && <p className="text-red-500">{error}</p>}

      {reportType === "Analytics" ? (
        <Bar
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: { display: true },
            },
            scales: {
              y: {
                beginAtZero: true,
              },
            },
          }}
        />
      ) : (
        renderList()
      )}
    </div>
  );
};

export default ServicewiseRevenueChart;
